import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  template: `
    <div class="error-container">
      <div class="error-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for does not exist.</p>
        <a routerLink="/login" class="btn btn-primary">Go to Login</a>
      </div>
    </div>
  `,
  styles: [`
    .error-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: var(--lb-bg);
    }
    .error-content {
      text-align: center;
    }
    .error-content h1 {
      font-size: 6rem;
      color: var(--lb-brand);
      margin-bottom: 0;
    }
    .error-content h2 {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
    .error-content p {
      color: var(--lb-text-muted);
      margin-bottom: 2rem;
    }
  `]
})
export class ErrorComponent { }
